import { ProgressiveBlur } from '../components/ProgressiveBlur';
import { InfiniteSlider } from '../components/InfiniteSlider';
import { useLanguage } from '../contexts/LanguageContext';

export default function SliderSection() {
  const { t, isRTL } = useLanguage();

  return (
    <section className="pb-2 overflow-hidden" style={{ backgroundColor: 'rgba(36, 68, 115, 0.75)', margin: 0, padding: 0 }}>
      <div className="group relative m-auto" style={{ margin: 0 }}>
        <div className="flex flex-col items-center md:flex-row">
          <div className={`md:max-w-46 md:border-r  ${isRTL ? 'md:border-l md:pl-6 md:pr-2' : 'md:border-r md:pr-6'}`}>
            <p className="text-end text-sm text-white">{t('home.sliderTitle')}</p>
          </div>
          <div className="relative py-6 md:w-[calc(95%)]">
            <InfiniteSlider
              durationOnHover={20}
              duration={40}
              gap={112}>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-1.png"
                  alt="Company 1"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain dark:invert"
                  src="./images/company-2.png"
                  alt="Company 2"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded px-0.5">
                <img
                  className="mx-auto max-h-[4.5rem] w-auto object-contain"
                  src="./images/company-3.png"
                  alt="Company 3"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-4.png"
                  alt="Company 4"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[2.5rem] w-auto object-contain"
                  src="./images/company-5.png"
                  alt="Company 5"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-6.png"
                  alt="Company 6"
                />
              </div>
              <div className="flex items-center justify-center">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-7.png"
                  alt="Company 7"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded px-0.5">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-8.png"
                  alt="Company 8"
                />
              </div>
              <div className="flex items-center justify-center bg-white rounded">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-9.png"
                  alt="Company 9"
                />
              </div>
              <div className="flex items-center justify-center bg-black rounded px-1">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-10.png"
                  alt="Company 10"
                />
              </div>
              <div className="flex items-center justify-center rounded px-1 bg-white">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-11.png"
                  alt="Company 11"
                />
              </div>
              <div className="flex items-center justify-center rounded px-0.5 bg-white">
                <img
                  className="mx-auto max-h-[4rem] w-auto object-contain"
                  src="./images/company-12.png"
                  alt="Company 12"
                />
              </div>

              
            </InfiniteSlider>

            <div className="bg-linear-to-r from-background absolute inset-y-0 left-0 w-20"></div>
            <div className="bg-linear-to-l from-background absolute inset-y-0 right-0 w-20"></div>
            <ProgressiveBlur
              className="pointer-events-none absolute left-0 top-0 h-full w-20"
              direction="left"
              blurIntensity={1}
            />
            <ProgressiveBlur
              className="pointer-events-none absolute right-0 top-0 h-full w-20"
              direction="right"
              blurIntensity={1}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
